import { ResponsiveLine } from '@nivo/line'
import Time from '@/gf/modules/Time'
import { CancellationMetricsChartDatum } from '../../types'

const CancellationLineChart = ({
  data,
  dataType,
}: {
  data: CancellationMetricsChartDatum[]
  dataType: 'count' | 'percent'
}) => {
  const chartData =
    dataType === 'count'
      ? data.map((cancellationChartDatum) => ({
          x: Time.toDateRangeString(cancellationChartDatum.from, cancellationChartDatum.to),
          y: cancellationChartDatum.cancellationMetrics.cancelledStoreOrdersCount,
        }))
      : data.map((cancellationChartDatum) => ({
          x: Time.toDateRangeString(cancellationChartDatum.from, cancellationChartDatum.to),
          y: cancellationChartDatum.cancellationMetrics.cancelledStoreOrdersPercent,
        }))
  const chartDataId = dataType === 'count' ? 'cancelled count' : 'cancelled percentage'
  const yFormat = dataType === 'count' ? '0' : '.0%'

  // periodIsOneDay is true if each tick mark on the x-axis is one day rather than a date period
  const periodIsOneDay = data[0] && data[0].from === data[0].to
  const bottomLegendOffset = periodIsOneDay ? 55 : 80
  const rightMargin = periodIsOneDay ? 45 : 60

  return (
    <ResponsiveLine
      data={[
        {
          id: chartDataId,
          data: chartData,
        },
      ]}
      margin={{ top: 20, right: rightMargin, bottom: bottomLegendOffset + 10, left: 70 }}
      xScale={{
        type: 'point',
      }}
      yScale={{ type: 'linear', min: 0, max: 'auto' }}
      yFormat={yFormat}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 45,
        legend: 'time',
        legendOffset: bottomLegendOffset,
        legendPosition: 'middle',
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'store order cancellations',
        legendOffset: -50,
        legendPosition: 'middle',
        format: yFormat,
      }}
      pointSize={10}
      pointBorderWidth={2}
      pointLabelYOffset={-12}
      useMesh
    />
  )
}

export default CancellationLineChart
